const usingServiceAdvantage = {
  en: {
    title: 'Korean BBQ Made Simple',
    desc: 'Better technology and faster service for very hungry customers!',
    items: [
      {
        title: 'Fast, Accurate Service with Tableside POS',
        image: `${process.env.ASSETS_PREFIX}/businesstype/korean-bbq-pos.jpg`,
        items: [
          {
            desc: 'Never miss an order as guests self-order their meats, veggies, and other items.',
          },
          {
            desc: 'Shave minutes off every order with handheld POS systems at every table',
          },
          {
            desc: 'Save big on labor, while upgrading the customer experience!',
          },
        ],
      },
      {
        title: 'More Tech = More Sales ',
        image: `${process.env.ASSETS_PREFIX}/businesstype/korean-bbq-handheld-pos-payment.jpg`,
        items: [
          {
            desc: 'Self service generates higher order volume, higher table turn over, and happier customers',
          },
          {
            desc: 'Allow guests to join waitlists and book reservations in advance!',
          },
          {
            desc: 'Use our loyalty, CRM, and gift card programs to turn one-time customers into your regulars!',
          },
        ],
      },
      {
        title: 'More Speed, More Profits',
        image: `${process.env.ASSETS_PREFIX}/businesstype/korean_bbq-service-type_usage_03.jpeg`,
        items: [
          {
            desc: 'Our POS system saves the average restaurant up to $8,000/month in labor costs',
          },
          {
            desc: 'Remove redundant costly tasks, which can boost sales volume, tips, staff productivity, and your bottom line!',
          },
        ],
      },
    ],
  },
  zh: {
    title: '简化烤肉店的服务流程',
    desc: '为顾客提供更快速的用餐体验',
    items: [
      {
        title: '升级顾客体验',
        image: `${process.env.ASSETS_PREFIX}/businesstype/korean-bbq-pos.jpg`,
        items: [
          {
            desc: '顾客可以提前在线上/店内排队取号，短信提醒到店用餐，减少等位时间',
          },
          {
            desc: '平板/扫码点单，顾客落座即可点单，用餐期间随时加菜，减少等待时间',
          },
          {
            desc: '有双语电子菜单供顾客选择，顾客可以通过图片和描述更好地了解菜品',
          },
        ],
      },
      {
        title: '提高运营效率 ',
        image: `${process.env.ASSETS_PREFIX}/businesstype/korean-bbq-handheld-pos-payment.jpg`,
        items: [
          {
            desc: '顾客一键自助下单，订单直达后厨，无需人工传递，减少漏单/错单概率',
          },
          {
            desc: '使用手持POS实现桌边结账，无需往返柜台打印小票、刷卡、打印收据',
          },
          {
            desc: '一站式管理您所有的订单，包括堂食、外卖、官网订单等，所有来源的订单直送后厨',
          },
          {
            desc: '利用POS产品减少人工重复性操作，将有限的人力投入到更有价值的服务上',
          },
        ],
      },
      {
        title: '提升餐厅利润',
        image: `${process.env.ASSETS_PREFIX}/businesstype/hotpot-service-type_usage_03.jpeg`,
        items: [
          {
            desc: '我们的POS产品帮助您在等位、点单、结账、订单管理等环节显著减少人力成本',
          },
          {
            desc: '关注顾客复购率，善用会员、积分、礼品卡、营销短信等方式发展您的回头客，提升营业额',
          },
          {
            desc: '自动化呈现餐厅订单、餐品、营业额等报表数据，帮助您更好地制定策略',
          },
        ],
      },
    ],
  },
};

export default usingServiceAdvantage;
